import { anatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const parts = anatomy("investmentProgressChips").parts("chip");

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);

const baseStyle = definePartsStyle({
  chip: {
    borderRadius: "0.3rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bg: "secondary",
    color: "white",
    border: "none",
    fontWeight: "bold",
  },
});

const sizes = {
  sm: definePartsStyle({
    chip: {
      minW: "32px",
      h: "32px",
      fontSize: "sm",
    },
  }),
  md: definePartsStyle({
    chip: {
      minW: "40px",
      h: "40px",
      fontSize: "md",
    },
  }),
  lg: definePartsStyle({
    chip: {
      minW: "48px",
      h: "48px",
      fontSize: "lg",
    },
  }),
};

const variants = {
  unknown: definePartsStyle({
    chip: {
      bg: "gray.400",
    },
  }),
  created: definePartsStyle({
    chip: {
      bg: "gray.400",
    },
  }),
  pending: definePartsStyle({
    chip: {
      bg: "yellow.400",
    },
  }),
  expedited: definePartsStyle({
    chip: {
      bg: "blue.400",
    },
  }),
  success: definePartsStyle({
    chip: {
      bg: "green.400",
    },
  }),
  error: definePartsStyle({
    chip: {
      bg: "red.400",
    },
  }),
  underpaid: definePartsStyle({
    chip: {
      bg: "red.400",
    },
  }),
  info: definePartsStyle({
    chip: {
      bg: "purple.400",
    },
  }),
  secondary: definePartsStyle({
    chip: {
      bg: "secondary.500",
    },
  }),
};

export const investmentProgressChipsTheme = defineMultiStyleConfig({
  baseStyle,
  sizes,
  variants,
  defaultProps: {
    size: "sm",
    variant: "unknown",
  },
});
